import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import ContentHeader from 'components/ContentBox/Global/ContentHeader'
import st from './StudyTestStudent.module.scss'
import { AttemptsScreen } from '../ShowTest/AttemptsScreen/AttemptsScreen'
import StudyTestResultStore from 'Stores/studyTestResultStore'
import MainTableRowScore from '../ShowTest/MainTableRowScore/MainTableRowScore'
import MainTableRowTime from '../ShowTest/MainTableRowTime/MainTableRowTime'
import AnswerQuestionNew from 'components/Modules/Study/TeacherResult/components/ResultAnswers/CompleteAnswers/CompleteAnswer/AnswerQuestionNew/AnswerQuestionNew'
import { localisationMaster } from 'Localisation/Localisation'
import StudyTestResult from '../components/StudyTestResult'

const StudyTestStudent = (props) => {
  let apiConf
  const { fetchTestResult, clearResultData } = StudyTestResultStore
  const [testInfo, setTestInfo] = useState([])
  const [initTestsList, setInitTestsList] = useState([false, []])
  const [filtredList, setFiltredList] = useState([])
  const [showedTry, setShowedTry] = useState(0)
  const [qValue, setqValue] = useState({ id: 0, value: null })

  const getQuestionButtonClassname = (id) => {
    let a = initTestsList[1][showedTry]?.answers_student?.find(
      (el) => el.question.id === id,
    )
    if (a?.question?.type === 'essay') {
      return `showInitTest__questBtn showInitTest__questBtn--yellow ${qValue.id === id ? 'showInitTest__questBtn--yellow--selected' : ''}`
    }
    if (!a || props.disableAnswers) return 'showInitTest__questBtn'
    if (!a?.correct_answers?.some((el) => el === false)) {
      return `showInitTest__questBtn showInitTest__questBtn--correct ${qValue.id === id ? 'showInitTest__questBtn--correct--selected' : ''}`
    } else {
      return `showInitTest__questBtn showInitTest__questBtn--wrong ${qValue.id === id ? 'showInitTest__questBtn--wrong--selected' : ''}`
    }
  }

  const changeQuestionHandler = (id) => {
    let a = initTestsList[1][showedTry]?.answers_student?.find(
      (el) => el.question.id === id,
    )
    if (!a) return
    setqValue({ id, value: a })
  }

  useEffect(() => {
    apiConf = {
      method: 'get',
      link: 'study/purpose_test/' + props.match.params['id'],
    }
    superAxiosRequest(apiConf).then((res) => setTestInfo(res.data))

    apiConf = {
      method: 'get',
      link: 'study/student_init_test',
      params: {
        //is_finish: false,
        purpose_test: props.match.params['id'],
        limit: 999,
      },
    }
    superAxiosRequest(apiConf).then((res) =>
      setInitTestsList([true, res.data.result]),
    )
  }, [])

  useEffect(() => {
    if (!initTestsList[0]) return
    let studentList = []
    let tryList = []
    initTestsList[1].map(
      (el) =>
        !studentList.includes(el.student.id) && studentList.push(el.student.id),
    )
    studentList.map((el) => {
      let a = initTestsList[1].filter((x) => x.student.id === el)
      if (a.length) tryList.push({ ...a[0], list: a })
    })
    setFiltredList([...tryList])
    if (
      initTestsList[1][showedTry]?.id &&
      initTestsList[1][showedTry]?.is_finish
    ) {
      fetchTestResult(initTestsList[1][showedTry]?.id)
    } else {
      clearResultData()
    }
  }, [
    initTestsList,
    testInfo,
    initTestsList[1][showedTry]?.id,
    fetchTestResult,
  ])

  const timeLeft = {
    seconds_until_start: testInfo.seconds_until_start,
    seconds_until_finish: testInfo.seconds_until_finish,
    created_at: testInfo.created_at,
    date_until: testInfo.date_until,
    finish_at: testInfo.finish_at,
  }

  return !(testInfo.length !== 0 && initTestsList[0]) ? (
    <Loader />
  ) : (
    <>
      <ContentHeader
        title={testInfo.name}
        breadСrumbs={[{ title: 'Ваши тесты', route: '/c/study/my-tests' }]}
      />
      <div className='studyTestMain'>
        <StudyTestResult values={testInfo} match={props.match} />
        {filtredList.length > 0 ? (
          <div className={st.conteinerClientTest}>
            <div className={st.attempts}>
              <AttemptsScreen
                attempts={initTestsList[1]}
                allAttemptsCount={testInfo?.try_count}
                showedTry={showedTry}
                setShowedTry={setShowedTry}
              />
            </div>
            <div className={st.delemetr}></div>
            <div className={st.rowScoreAndTime}>
              <MainTableRowScore currentTry={initTestsList[1][showedTry]} />
              <MainTableRowTime
                timeLeft={timeLeft}
                attempts={initTestsList[1]}
                showedTry={showedTry}
              />
            </div>
            <div className={st.delemetr}></div>
            <div className={st.showTest__questions}>
              {initTestsList[1][showedTry]?.is_correct_answers &&
                initTestsList[1][showedTry]?.is_correct_answers.map(
                  (el, index) => {
                    return (
                      <div
                        key={index}
                        className={getQuestionButtonClassname(el.id)}
                        onClick={() => changeQuestionHandler(el.id)}
                      >
                        {index + 1}
                      </div>
                    )
                  },
                )}
            </div>
            <div className={`${st.delemetr}`}></div>
            <div className='showInitTest_question'>
              {/*{!props.disableAnswers && qValue.value !== null ?*/}
              {/*    <AnswerQuestionNew answer={qValue.value} item={props.item} modal/> :*/}
              {/*    null}*/}
              {!props.disableAnswers && qValue.value !== null && (
                <div className={st.paddingContainer}>
                  <AnswerQuestionNew
                    answer={qValue.value}
                    item={props.item}
                    modal
                  />
                </div>
              )}
            </div>
          </div>
        ) : null}
        {!props.disableAnswers &&
          qValue.value === null &&
          initTestsList[1][showedTry]?.test_status === 'finished' && (
            <div className={st.noResult}>
              {localisationMaster('text_14', 'study/test') ||
                'Пока нет ни одного результата'}
            </div>
          )}
      </div>
    </>
  )
}

export default StudyTestStudent
